import React from "react";
import Page from "./components/Page";
import store, { persistor } from "./store/store";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react'
import "./styles/components/Content.css";
import "./styles/components/Footer.css";
import "./styles/components/SearchSelect.css";
import "./styles/App.css";
import "./styles/components/Header.css";
import "./styles/components/GoalCard.css";
import "./styles/components/SidePanel.css";

const App = () => {
    return (
        <div className="App">
            <Provider store={store}>
                <PersistGate persistor={persistor} loading={null}>
                    <Page/>
                </PersistGate>
            </Provider>
        </div>
    )
}

export default App;
